module.exports = "<div class=\"col-xs-12 col-md-8 col-md-offset-2\">\n      <div class=\"rowplaceholder\">\n        <div>\n          <p class=\"main-message\">Coming Soon</p>\n          <p class=\"sub-message\">Thank you for your patience</p>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/placeholder/placeholder.html
// module id = HESU
// module chunks = 3